var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHoursIconBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3719_37818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 19.9902C1.12359 19.9813 -3.34124 9.2014 2.92906 2.91918C6.65128 -0.959754 13.3489 -0.960379 17.0711 2.91934C23.3414 9.2021 18.876 19.9818 10.0001 19.9902ZM10.0001 1.55278C5.34761 1.55278 1.56257 5.33781 1.56257 9.99026C2.02605 21.1837 17.9757 21.1805 18.4375 9.99018C18.4375 5.33785 14.6525 1.55278 10.0001 1.55278ZM13.6384 12.5238L11.1701 10.0555C11.1919 9.69097 11.0364 9.34257 10.7809 9.11648C10.7812 9.10831 10.7813 9.10011 10.7813 9.09187V4.52156C10.7401 3.485 9.25971 3.48578 9.21881 4.52156V9.09187C9.21881 9.10011 9.21897 9.10831 9.2192 9.11648C8.40221 9.8478 8.95643 11.2175 10.0653 11.1604L12.5335 13.6287C12.8386 13.9338 13.3333 13.9338 13.6384 13.6287C13.9435 13.3235 13.9435 12.8289 13.6384 12.5238Z",
    fill: "#2667B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3719_37818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoursIconBlue);
export default __webpack_public_path__ + "static/media/hours_icon_blue.6699e2113919874f39754dd912c4a297.svg";
export { ForwardRef as ReactComponent };